import { useGetHttp } from "../../../../hooks/http/http.hook";

export interface ICPV {
  min: number;
  max: number;
  default: number;
}

export interface IPayoutPercentage {
  min: number;
  max: number;
  default: number;
}

interface IResponse {
  cpv: ICPV;
  payoutPercentage: IPayoutPercentage;
}

export function useGetCampaignConfigHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/campaigns/config",
  });
}
